module.exports = __webpack_public_path__ + "3b696c5e8c55321863bfbf03ef0c0ff3.ttf";